angular.module('aprima-legacy-common').factory(
    'LanguageFactoryJs', ['gettextCatalog', function LanguageFactory(gettextCatalog) {

        'use strict';

        function setLang(language) {
            gettextCatalog.currentLanguage = language;
        }

        return {
            setLang: setLang,
        };
    }]);
